import React from 'react';
import PropTypes from 'prop-types';

import {
  ContributionContents,
  ContributionContent,
  DownloadDescription,
  DownloadTag,
} from './styles';
import pdfImage from '../../../assets/icons/pdf.svg';

const DBCard = ({ link, handleDownloadAnalytics }) => {
  return (
    <ContributionContents>
      <img src={pdfImage} alt="how to value contributions" />
      <ContributionContent>
        <DownloadDescription>
          How to value your contributions
        </DownloadDescription>
        <DownloadTag
          data-test="download-tag"
          target="_blank"
          href={link ? link : '#'}
          download
          onClick={() =>
            handleDownloadAnalytics(
              'download',
              'How to value your contributions',
              'Download'
            )
          }
        >
          Download
        </DownloadTag>
      </ContributionContent>
    </ContributionContents>
  );
};

export default DBCard;

DBCard.propTypes = {
  link: PropTypes.string,
  handleDownloadAnalytics: PropTypes.func.isRequired,
};
